<div class="showcase"></div>
<div class="content">
  <div class="title">Director de Comedia</div>
  <div>
    <p class="text">
      Como Director uso el lenguaje de la comedia para transmitir ideas en todos
      los formatos. A cada proyecto le imprimo siempre el tratamiento artístico
      y cinematográfico necesario para lograr productos audiovisuales de
      comedia, pocas veces vista en Latinoamérica.
    </p>
    <p class="text">
      Desde 2003 he creado, escrito, producido y dirigido cortometrajes, sketch,
      series, stand up comedy, branding, publicidad y tv, haciendo propuestas
      innovadoras, retadoras y ampliamente creativas.
    </p>
    <p class="text">
      Siempre exploro un mundo de posibilidades, códigos visuales, artísticos y
      narrativos, para crear piezas efectivas y artísticas, cargadas de buena
      comedia. Mi humor está basado en temas completamente universales y me
      apasiona crear contenidos maravillosos que saquen sonrisas en cualquier
      lugar del mundo.
    </p>
    <p class="text">
      Mi estilo único mezcla lo clásico con lo moderno, lo elevado con lo pueril
      y lo racional con lo absurdo. Siempre creando un tributo a los grandes y
      ofreciendo un vistazo al futuro de la comedia.
    </p>
  </div>
  <div class="reel-actor">
    <div class="reel-actor-container">
      <div class="category-title sub-title">Reel</div>
      <iframe
        width="100%"
        src="https://www.youtube.com/embed/M0DpQRNs2u8"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
  <div class="sircomedia">
    <div class="sub-title">Sircomedia Productions</div>
    <p class="text">
      Desde mi propia productora independiente, creamos contenido cómico
      original en sus distintos estilos y formatos para todas las plataformas.
      Estamos listos para traer a la vida la Comedia más hilarante, auténtica y
      divertida que se haya conocido. Sircomedia Productions lo hace posible.
      ¡Hagamos Comedia con C mayúscula!
    </p>
  </div>
  <a class="t-icon" href="https://www.imdb.com/name/nm2907273/" target="_blank">
    <fa-icon [icon]="faImdb"></fa-icon>
  </a>
  <button
    [routerLink]="'/contacto'"
    class="button-box tomame-button gray"
    mat-button
  >
    ¡Tómame ya!
  </button>

  <go-to-top></go-to-top>

  <who-fran-want></who-fran-want>
</div>
